import { render, staticRenderFns } from "./additionaldocuments.html?vue&type=template&id=1a9ce220&scoped=true&"
import script from "./AdditionalDocuments.vue?vue&type=script&lang=ts&"
export * from "./AdditionalDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ce220",
  null
  
)

export default component.exports